// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { CONSENT_TOPIC } from './../../../types/next/blocks/consentsBlock'
import { blockBaseSettingsSchema, iBlockSchema } from './baseBlock.zod'
import { sortableSchema, universallyUniqueIdSchema } from './common.zod'

export const consentItemIdSchema = universallyUniqueIdSchema

export const consentTopicSchema = z.nativeEnum(CONSENT_TOPIC)

export const consentItemSchema = sortableSchema.extend({
  required: z.boolean(),
  topics: z.array(z.union([consentTopicSchema, z.string()])),
  text: z.string().optional().nullable()
})

export const consentsBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.CONSENTS),
  settings: blockBaseSettingsSchema.and(
    z.object({
      items: z.record(consentItemIdSchema, consentItemSchema)
    })
  )
})

export const consentItemBlockValueSchema = z.object({
  agreed: z.boolean(),
  topic: z.union([consentTopicSchema, z.string()]),
  text: z.string().nullable(),
  time: z.date()
})

export const consentsBlockValueSchema = z.record(
  consentItemIdSchema,
  consentItemBlockValueSchema
)
